const classPhoto = {
  path: 'classPhoto/:myClassId',
  component: resolve => require(['../../../../components/pages/student_user/classPhoto'], resolve),
  props: true
}
export default classPhoto



// WEBPACK FOOTER //
// ./src/router/pages/student_user/classPhoto/index.js